import { useContext, useEffect } from 'react';

import { HubConnectionState } from '@microsoft/signalr';

import { SignalRConnectionContext } from './SignalRConnectionContext';

export const useOnSignalRMethod = <TArgs extends unknown[]>(
  methodName: string,
  callback: (...args: TArgs) => void
) => {
  const { connection, state } = useContext(SignalRConnectionContext);

  useEffect(() => {
    if (state !== HubConnectionState.Connected || !methodName || !connection) {
      return;
    }

    const wrappedCallback = (...args: TArgs) => {
      try {
        callback(...args);
      } catch (error) {
        console.error(`Error in SignalR method '${methodName}':`, error);
      }
    };

    connection.on(methodName, wrappedCallback);

    return () => {
      try {
        connection.off(methodName, wrappedCallback);
      } catch (error) {
        console.warn(`Failed to unsubscribe from SignalR method '${methodName}':`, error);
      }
    };
  }, [connection, methodName, callback, state]);
};
